export var Name = 'replace-shopping-bag-item';
export var ReplaceShoppingBagItemEvent = Name;